import { ReactNode } from 'react';
import { ModalHeader } from 'core/common/ui/ui-kit';
import { PaymentError } from 'core/payments/entities';
import { PaymentFormFailed } from '../PaymentFormFailed';
import { DrawerStyled } from './styled';

type PaymentDrawerFailedProps = {
  paymentError: PaymentError | null;
  expressButton?: ReactNode;
  onClose: () => void;
  onTryAgain: () => void;
};

export const PaymentDrawerFailed = ({
  paymentError,
  expressButton,
  onClose,
  onTryAgain,
}: PaymentDrawerFailedProps) => {
  return (
    <DrawerStyled open anchor="bottom" onClose={onClose}>
      <ModalHeader onClose={onClose} />
      <PaymentFormFailed
        paymentError={paymentError}
        onTryAgain={onTryAgain}
        expressButton={expressButton}
      />
    </DrawerStyled>
  );
};
